module.exports = __webpack_public_path__ + "img/mtl-logo-188.8f70a510.jpg";